/* eslint-disable jsx-a11y/heading-has-content */
import React, {useState, useEffect} from 'react';
import {db} from '../firebase.js';
import { collection, onSnapshot,} from "firebase/firestore";
import Navbar from './Navbar'


const ViewRecordHistory = () => {
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    onSnapshot(collection(db, 'siniestros'),
    (snapshot) => {
      const data = snapshot.docs.map(doc => doc.data());
      setHistorial((prev)=>([...prev, ...data]));

    }
    )
  },[]);
console.log(historial);

return (
    <div>
    <Navbar></Navbar>  

    <h1 className='title-home mx-3 mt-3'> Historial de Siniestros</h1>
    {historial?.map((element)=> (
      <div key={element.Card}>
    <div className="card bg-white mx-3" > 

    <div className="card-body bg-white mx-3">
      <p className='card-title bg-white'><strong className='bg-white'>SINIESTRO N°: {element.Number}</strong></p>
      <p className=' card text'>Tipo de Siniestro: {element.TypeSini}</p>
      <p className=' card text'>Fecha del siniestro: {element.Date}</p>
      <p className=' card text'>{element.Status}</p>
      <p className=' card texts'>Rut del asegurado: {element.Rut}</p>
      </div>
      </div>
      </div>
    )
    )}

  </div>
);
};

export default ViewRecordHistory
